import axios, { AxiosRequestConfig } from "axios";
import {
  decryptPayload,
  encryptPayload,
  encryptPayloadV2,
} from "../helpers/Encryption";
import { baseURl, encryptionKey } from "./Config";

const largeResponse = [
  "/Xlxs",
  "/Xlxs2",
  "/BulkValidation",
  "/GenerateReportDaily",
  "/GenerateReportRange",
  "/SendBatchNumber",
  "/UpdateForApproval",
  "/GetForApproval",
];

const largeRequest = ["/Xlxs", "/Xlxs2", "/BulkValidation", "/BulkSend"];
const specialRequest = ["/generateotp"];

const apiContext = axios.create({
  baseURL: baseURl,
});
//encrypting the request
apiContext.interceptors.request.use(
  (config: any) => {
    if (largeRequest.includes(config.url)) {
      // do nothing
    } else if (specialRequest.includes(config.url)) {
      config.headers["Content-Type"] = "text/plain";
      config.data = encryptPayloadV2(config.data);
    } else if (config.data !== undefined) {
      config.headers["Content-Type"] = "text/plain";
      config.data = encryptPayload(config.data);
    }

    return config;
  },
  (error: unknown) => {
    return Promise.reject(error);
  }
);
//decrypting the response
apiContext.interceptors.response.use(
  (response: any) => {
    if (largeResponse.includes(response.config.url)) {
      // do nothing
    } else response.data = decryptPayload(response.data, encryptionKey);
    return response;
  },
  (error: unknown) => {
    return Promise.reject(error);
  }
);

export { apiContext };
